import { useState } from 'react';
import { useAuth } from '../AuthContext';
import packageJson from '../../package.json';
import Loading from './Loading';

const baseUrl = packageJson.apiUrl;

export default function LoginModal({ onClose }) {
  const { login } = useAuth();

  const [method, setMethod] = useState('');
  const [factor1, setFactor1] = useState('');
  const [factor2, setFactor2] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError(null);

    const query = [];
    const params = { method, factor1, factor2 };
    if (typeof params === 'object' && params !== null) {
        for (const key in params) {
            if (params[key] !== null && typeof params[key] !== 'undefined') {
                query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
            }
        }
    }

    try {
      setLoading(true);
      const response = await fetch(baseUrl + '/new/flickrmap/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: query.join('&'),
      });

      setLoading(false);

      if (!response.ok) {
        setError('Invalid login');
        return;
      }

      const { token } = await response.json();
      login(token);
      typeof onClose === "function" && onClose(true);
    } catch (err) {
      setError('Something went wrong');
      setLoading(false);
    }
  }

  return (
    <div className="modal">
        <div className="modal-window">
          <h2>Login</h2>
        { loading ? <Loading /> : 
        <form onSubmit={handleLogin}>
            <div className="p5">
              <input
                type="text"
                placeholder="Method"
                value={method}
                onChange={(e) => setMethod(e.target.value)}
                required
              />
            </div>
            <div className="p5">
            <input
              type="password"
              placeholder="Factor 1"
              value={factor1}
              onChange={(e) => setFactor1(e.target.value)}
              required
            />
            </div>
            <div className="p5">
            <input
              type="password"
              placeholder="Factor 2"
              value={factor2}
              onChange={(e) => setFactor2(e.target.value)}
              required
            />
            </div>
            {error && <p className="p5 error">{error}</p>}
            <div className="p5">
            <button type="submit" className="submit">Log in</button>
            {' '}
            <button type="button" onClick={() => typeof onClose === "function" && onClose(false)}>
                Cancel
            </button>
            </div>
        </form> }
        </div>
    </div>
  );
}
